

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../styles/teamDetails.css";
import TeamMemberAccRej from "./TeamMemberAccRej";
import {
  createTeamAction,
  deleteTeamAction,
  fetchTeamDetails,
  jointTeamReqAction,
  leaveTeamAction,
  removeMemberAction,
} from "../redux/slices/teamSlices";

const Team = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    if (user?.teamDetails) {
      dispatch(fetchTeamDetails());
    }
  }, []);
  const UserstoreData = useSelector((store) => store?.users);
  const {user} = UserstoreData;

  const TeamStoreData = useSelector((store) => store?.team);
  const { team, message, appError: teamError } = TeamStoreData;

  const removeMember = (id) => {
    const data = {
      memberId: id,
    };
    dispatch(removeMemberAction(data));
    dispatch(fetchTeamDetails());
    // window.location.reload();
  };

  const deleteTeam = () => {
    dispatch(deleteTeamAction());
    dispatch(fetchTeamDetails());
    // window.location.reload();
  };

  const leaveteam = () => {
    dispatch(leaveTeamAction());
  };

  const [teamName, setTeamName] = useState("");

  const handleChangeTeamName = (e) => {
    setTeamName(e.target.value);
  };

  const handleJoin = () => {
    const data = {
      teamName: teamName,
    };
    dispatch(jointTeamReqAction(data));
  };

  const handleCreate = () => {
    const data = {
      teamName: teamName,
    };
    dispatch(createTeamAction(data));
    dispatch(fetchTeamDetails());
  };
  console.log(user.teamRequest);
  return (
    <>
      {team ? (
        <div Style="color : white" className="team_card">
          <h1 Style="color: #4caf50">{team?.name}</h1>
          <h3>Leader :</h3>
          <h3 id="team_names">{team?.leaderId?.email}</h3>
          <h3 id="team_names">Members: </h3>
          {team?.teamMembersId.map((member, index) => (
            <div className="team_mem_card">
              <h4 id="team_mem_names">{member?.email}</h4>
              {user?.id === team?.leaderId?.id ? (
                <button
                  type="button"
                  id="btn-delete"
                  onClick={() => removeMember(member.id)}
                  className="btn btn-success mt-1"
                >
                  Remove
                </button>
              ) : null}
            </div>
          ))}

          {user?.id === team?.leaderId?.id ? (
            <button
              type="button"
              id="delete_btn"
              onClick={deleteTeam}
              className="btn btn-success mt-1"
            >
              Delete Team
            </button>
          ) : (
            <button
              type="button"
              onClick={leaveteam}
              className="btn btn-success mt-1"
            >
              Leave
            </button>
          )}
          {team ? <TeamMemberAccRej /> : null}
        </div>
      ) : (
        <div className="form-parent">
          <div>
            <h2 style={{ color: "greenyellow" }}>Join or Create a Team</h2>
            <label htmlFor="teamName">Team Name:</label>
          </div>
          <form>
            <input
              type="text"
              id="teamName"
              value={teamName}
              onChange={handleChangeTeamName}
              required
              placeholder="Enter team name"
            />
            <br />
            <div className="buttons_row">
            <button type="button" onClick={handleJoin}>
              Join
            </button>
            <button type="button" onClick={handleCreate}>
              Create
            </button>
            </div>

            {/* {teamError ? <p Style="color : white" id="msg">{teamError}</p> : null}
            {message ? <p Style="color : white" id="msg">{message}</p> : null} */}
          </form>
        </div>
      )}
    </>
  );
};

export default Team;
